import script from "./Agenda.vue?vue&type=script&setup=true&lang=js"
export * from "./Agenda.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__